// @flow
import { getCategoryIdsFromQueryParams, getKeywordFromQueryParams } from '../../utils/queryParams';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import CatalogAd from './CatalogAd';
import { connect } from 'react-redux';
import ConsignmentAd from './ConsignmentAd';
import { getAdUnit } from '../../redux/modules/adUnit';
import { getCategoryIdsFromPathname } from '../../utils/urls';
import { trackAdUnitClick } from '../../redux/modules/analytics';

type Props = {
    adUnit: any,
    className: string,
    trackAdUnitClick: Function,
};

const mapStateToProps = (state, { isLandingPage, isCalenderPage, pageName, pathname, queryParams }) => {
    const keywords = getKeywordFromQueryParams(queryParams);
    let categoryIds = isLandingPage ? getCategoryIdsFromPathname(pathname) : getCategoryIdsFromQueryParams(queryParams);
    categoryIds = isCalenderPage ? [...(categoryIds || []), 0] : categoryIds;

    const adUnit = getAdUnit(state, categoryIds, keywords, pageName);

    return { adUnit };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            trackAdUnitClick,
        },
        dispatch
    );

class AdContainer extends Component<Props> {
    trackClick = () => {
        const { adUnit } = this.props;
        const { adUnitId, catalogId, sellerId } = adUnit;

        this.props.trackAdUnitClick({ adUnitId, catalogId, sellerId });
    };

    render() {
        const { adUnit, className } = this.props;

        if (!adUnit || !adUnit.adUnitId) {
            return null;
        }

        const adUnitComponent = adUnit.consignment ? (
            <ConsignmentAd className={className} adUnit={adUnit} trackClick={this.trackClick} />
        ) : (
            <CatalogAd className={className} adUnit={adUnit} trackClick={this.trackClick} />
        );

        return adUnitComponent;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdContainer);
